import {assertAndContinue} from 'Asserts';
import * as EventConstants from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import {CellInsertMode} from 'notebook/tables/excess/FormulaUtil';
import {TypedValue} from 'notebook/tables/TableConstants';

interface SetFormulaArgs {
  tableNamespace: string;
  tableName: string | null;
  formula: string;
  typedValue: TypedValue | null;
  editing: boolean;
  selection: BenchlingSelection | null;
  cellInsertMode?: CellInsertMode;
}

export function setFormula({
  tableNamespace,
  tableName,
  formula,
  typedValue,
  editing,
  selection,
  cellInsertMode,
}: SetFormulaArgs): void {
  // Make sure we didn't forget typedValue.
  // To clear typedValue, you can pass in `null`.
  assertAndContinue(typedValue !== undefined, 'typedValue is required');

  AppDispatcher.dispatch({
    actionType: EventConstants.SPREADSHEET_SET_FORMULA,
    tableNamespace,
    tableName,
    formula,
    typedValue,
    editing,
    selection,
    cellInsertMode,
  });
}

export function setTypedValue(typedValue: TypedValue | null): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.SPREADSHEET_SET_TYPED_VALUE,
    typedValue,
  });
}
